import React from 'react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-400 py-12 border-t border-gray-800" data-id="element-121">
      <div className="container mx-auto px-4 text-center" data-id="element-122">
        <div className="mb-6" data-id="element-123">
          <span className="text-2xl font-display text-white tracking-widest" data-id="element-124">
            MEGAPACK MUNDIAL 2026
          </span>
        </div>
        <p className="mb-6 max-w-md mx-auto text-sm" data-id="element-125">
          Este sitio no está afiliado, respaldado ni patrocinado por FIFA o
          Panini. Todos los nombres de productos, logotipos y marcas son
          propiedad de sus respectivos dueños.
        </p>
        <div className="flex justify-center gap-6 text-sm" data-id="element-126">
          <a href="#" className="hover:text-white transition-colors" data-id="element-127">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-128">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-129">
            Contacto
          </a>
        </div>
        <p className="mt-8 text-xs text-gray-600" data-id="element-130">
          &copy; {new Date().getFullYear()} Megapack Mundial. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}